/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverPenaltyListedAdminDto } from '../models/DriverPenaltyListedAdminDto';
import type { DriverPenaltySeverity } from '../models/DriverPenaltySeverity';
import type { DriverPenaltyStatus } from '../models/DriverPenaltyStatus';
import type { GetDriverPenaltiesDriverResponse } from '../models/GetDriverPenaltiesDriverResponse';
import type { Pagination1OfDriverPenaltyListedAdminDto } from '../models/Pagination1OfDriverPenaltyListedAdminDto';
import type { PostDriverPenaltyAdminRequest } from '../models/PostDriverPenaltyAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverPenaltiesService {
    /**
     * @returns GetDriverPenaltiesDriverResponse OK
     * @throws ApiError
     */
    public static getDriverPenaltiesDriver({
        createdAtFrom,
        createdAtTo,
        page,
        limit,
    }: {
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<GetDriverPenaltiesDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverpenalties',
            query: {
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverPenalties`
     * @returns Pagination1OfDriverPenaltyListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverPenaltiesAdmin({
        driverId,
        regionId,
        status,
        severity,
        createdAtFrom,
        createdAtTo,
        detectedAtFrom,
        detectedAtTo,
        page,
        limit,
    }: {
        driverId?: number,
        regionId?: number,
        status?: DriverPenaltyStatus,
        severity?: DriverPenaltySeverity,
        createdAtFrom?: string,
        createdAtTo?: string,
        detectedAtFrom?: string,
        detectedAtTo?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverPenaltyListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverpenalties',
            query: {
                'driverId': driverId,
                'regionId': regionId,
                'status': status,
                'severity': severity,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'detectedAtFrom': detectedAtFrom,
                'detectedAtTo': detectedAtTo,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverPenalties`
     * @returns DriverPenaltyListedAdminDto OK
     * @throws ApiError
     */
    public static postDriverPenaltyAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverPenaltyAdminRequest,
    }): CancelablePromise<DriverPenaltyListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverpenalties',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverPenalties`
     * @returns DriverPenaltyListedAdminDto OK
     * @throws ApiError
     */
    public static patchApproveDriverPenaltyAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverPenaltyListedAdminDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/v1/driverpenalties/{id}/approve',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverPenalties`
     * @returns DriverPenaltyListedAdminDto OK
     * @throws ApiError
     */
    public static patchRejectDriverPenaltyAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverPenaltyListedAdminDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/v1/driverpenalties/{id}/reject',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
